import {createApp} from 'vue'
import App from './App.vue'
import createMainRouter from "@/router/main-router";
import VueAxios from "vue-axios";
import {createPinia} from "pinia";
import axios from 'axios';
import FloatingVue from 'floating-vue'
import '@/assets/scss/floatingvue.scss'

import 'vue-toast-notification/dist/theme-default.css';
import ToastPlugin from "vue-toast-notification";
import VueSkeletonLoader from 'vue3-skeleton-loader';
import 'vue3-skeleton-loader/dist/style.css';
import VueSimpleSuggest from '@vojtechlanka/vue-simple-suggest';
import Select2 from 'vue3-select2-component';
import '@/tools/http-client'
import './registerServiceWorker'

const app = createApp(App);
const pinia = createPinia();



app.use(VueAxios, axios);
app.use(createMainRouter());
app.use(pinia);

app.use(FloatingVue);
app.use(ToastPlugin);

app.component('VueSimpleSuggest', VueSimpleSuggest);
app.component('VueSelect2', Select2);
app.component('VueSkeletonLoader', VueSkeletonLoader);

app.mount('#app')
